/** Technical transport details belong in diagnostics, not the editor's user-facing UI. */
export function editorUserMessage(value:unknown,fallback='요청을 완료하지 못했습니다. 연결을 확인한 뒤 다시 시도해 주세요.'):string{
 const message=typeof value==='string'?value:value instanceof Error?value.message:'';
 if(!/[가-힣]/.test(message)||/(?:https?:\/\/|data:|blob:|Failed to fetch|TypeError|\n\s*at )/i.test(message))return fallback;
 return message.slice(0,300);
}
